import isEmpty from "lodash/isEmpty";
import moment from "moment";
import { LOCAL_DATA_APPEND_KEY } from "@/store/actions/studentDetailsActions";

export function setLocalData(key, value) {
    if (window.localStorage) {
        window.localStorage.setItem(key, JSON.stringify(value));
    }
}

export function removeLocalData(key) {
    if (window.localStorage) {
        window.localStorage.removeItem(key);
    }
}

export function getLocalData(key) {
    if (window.localStorage) {
        let value = window.localStorage.getItem(key);
        if (value && value !== "null") return JSON.parse(value);

        return value;
    }
}

export function removeOldStudentData() {
    if (window.localStorage) {
        const localData = { ...window.localStorage };
        if (isEmpty(localData)) {
            return;
        }

        let currentItem;
        for (const key in localData) {
            if (key.startsWith(LOCAL_DATA_APPEND_KEY)) {
                currentItem = JSON.parse(localData[key]);
                if (moment().format("DD_MM_YYYY") !== currentItem.date) {
                    removeLocalData(key);
                }
            }
        }
    }
}
